import React, { useState, useEffect } from "react";

import {
  Container,
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

function PricingComponent({ buttons, tiers }) {
  const [planStatus, setPlanStatus] = useState(null);

  useEffect(() => {
    const status = secureLocalStorage.getItem("Status");
    if (status != null) {
      setPlanStatus(status);
    }
  }, []);
  const navigate = useNavigate();
  return (
    <Container maxWidth="md" component="main" style={{ position: "relative" }}>
      <Grid container spacing={5} alignItems="flex-end" m="auto">
        {tiers.map((tier) => (
          <Grid
            item
            key={tier.id}
            xs={10}
            sm={4}
            md={5}
            margin="auto 0"
            paddingLeft={0}
          >
            <Card
              sx={{
                backgroundColor: "#201939",
                border:
                  (tier.isSubscribed &&
                    tier.id == "7945" &&
                    planStatus == "paid") ||
                  (tier.isSubscribed &&
                    tier.id == "7952" &&
                    planStatus == "none")
                    ? "12px solid #66BB6A"
                    : null,
              }}
            >
              <CardHeader
                title={tier.title}
                subheader={tier.subTitle}
                titleTypographyProps={{
                  align: "center",
                  sx: { color: "var(--white)" },
                }}
                action={
                  (tier.isSubscribed &&
                    tier.id == "7945" &&
                    planStatus == "paid") ||
                  (tier.isSubscribed &&
                    tier.id == "7952" &&
                    planStatus == "none") ? (
                    <CheckCircleIcon sx={{ color: "success.main" }} />
                  ) : null
                }
                subheaderTypographyProps={{
                  align: "center",
                  sx: { color: "#ffffff" },
                }}
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                }}
              />

              <CardContent sx={{ flexDirection: "column", pt: "2vw" }}>
                <Box display="flex" justifyContent="center" mb={4}>
                  <Typography component="h2" variant="h3" color="var(--white)">
                    ${tier.price}
                  </Typography>
                </Box>
                <Divider style={{ background: "var(--color-white-50)" }} />
                <Box mt={5} mb={2}>
                  {tier.description.map((line, index) => (
                    <Box
                      key={index}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <ArrowForwardIosIcon
                        sx={{
                          fontSize: 20,
                          color: "var(--white)",
                          marginRight: 1,
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        align="center"
                        sx={{ color: "text.primary", color: "var(--white)" }}
                      >
                        {line}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
              <CardActions>
                {(tier.isSubscribed &&
                  tier.id == "7945" &&
                  planStatus == "paid") ||
                (tier.isSubscribed &&
                  tier.id == "7952" &&
                  planStatus == "none") ? (
                  <Button
                    fullWidth
                    variant="contained"
                    disabled
                    style={{ background: "var(--color-maroon)" }}
                  >
                    {buttons.subscribed.buttonText}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    variant="contained"
                    style={{ background: "var(--color-maroon)" }}
                    onClick={() =>
                      navigate(
                        planStatus == "paid"
                          ? "/stripe/product0"
                          : "/stripe/product1"
                      )
                    }
                  >
                    {buttons.nonsubscribed.buttonText}
                  </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default PricingComponent;
